import { ResourceType } from '../enums';

export interface CompanyResource {
  id: string;
  type: ResourceType.Company;
  attributes: CompanyAttributes;
}

export interface CompanyAttributes {
  [key: string]: number | string | Date | string[] | undefined;
  id: number;
  companyName: string;
  companyNameText?: string;
  dateFounded: string;
  description: string;
  ecosystemName: string;
  headquarters: string;
  latestRoundDate: string;
  latestRoundType: string;
  linkedInUrl: string;
  logoUrl: string;
  logoUrlCdn?: string;
  marketplaceTags: string[];
  primaryTag: string;
  secondaryTag?: string;
  tags: string[];
  twitter: string;
  website: string;
}

/**
 * @description Creates a new company object with minimal defaults.
 * @function
 * @return {CompanyResource}
 */
export function defaultCompanyResource(): CompanyResource {
  return {
    type: ResourceType.Company,
    id: '',
    attributes: {
      id: 0,
      companyName: '',
      dateFounded: '',
      description: '',
      ecosystemName: '',
      headquarters: '',
      latestRoundDate: '',
      latestRoundType: '',
      linkedInUrl: '',
      logoUrl: '',
      logoUrlCdn: '',
      marketplaceTags: [],
      primaryTag: '',
      tags: [],
      twitter: '',
      website: '',
    },
  };
}
